/**
 * Mega Menu — The Jewel Dude
 * Desktop: JS hover-intent drives the panel (open on enter, close on a short
 *          grace delay) so the cursor can cross the gap into the full-width
 *          panel without it disappearing; JS also handles touch + ESC + click-outside.
 * Mobile: coordinate-based capture listeners bypass Stiletto's event interception.
 */
(function () {
  'use strict';

  /* ── Desktop "vault" drawer ──────────────────────────────────
     The old nested full-width dropdown + body-level backdrop are retired.
     Root cause of the broken state: on this Stiletto theme the header is
     position:static / z-index:auto and its section sits at z-index:500, so a
     body-level backdrop (z-9998) painted OVER the panel and ate the clicks.
     The vault is ONE self-contained fixed layer appended to <body> — its own
     scrim + panel — so nothing competes for stacking, exactly like the mobile
     drawer. SHOP opens it; ESC / scrim / ✕ close it. Header colour logic and
     the horizontal nav bar are untouched. */

  function syncTriggers(isOpen) {
    document.querySelectorAll('[data-mega-trigger]').forEach(function (t) {
      t.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function initVault() {
    var vault = document.getElementById('tjd-vault');
    if (!vault) return;

    /* Portal to <body> so its fixed layer escapes the header stacking context
       (mirrors the mobile drawer). Survives any header re-render. */
    document.body.appendChild(vault);

    function openVault() {
      vault.classList.add('tjd-vault--open');
      vault.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tjd-vault-open');
      document.body.style.overflow = 'hidden';
      syncTriggers(true);
    }
    function closeVault() {
      vault.classList.remove('tjd-vault--open');
      vault.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tjd-vault-open');
      document.body.style.overflow = '';
      syncTriggers(false);
    }

    /* ── Event wiring — document-level CAPTURE + coordinate hit-testing ──
       This theme (Stiletto) re-renders the header section after load AND has
       page-wide click interference that stops clicks from reaching interior
       elements, so a handler bound directly to the SHOP button never fires
       (verified live). The mobile hamburger already works around this exact
       problem the same way. So: one capture-phase document listener. The SHOP
       trigger is matched by hit-testing the pointer against its live rect
       (immune to the element being replaced); the vault's own controls
       (close / expand) are routed by target — the vault is a body-level element
       we own, reachable in the capture phase before any interference. */

    function hits(el, x, y) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
    }

    var lastToggle = 0;
    function route(x, y, target, e) {
      /* SHOP trigger → toggle (coordinate hit-test) */
      var trigger = document.querySelector('[data-mega-trigger]');
      if (trigger && hits(trigger, x, y)) {
        if (e.cancelable) e.preventDefault();
        e.stopImmediatePropagation();
        var now = Date.now();
        if (now - lastToggle < 350) return;   // debounce click+touchend double-fire
        lastToggle = now;
        if (vault.classList.contains('tjd-vault--open')) closeVault();
        else openVault();
        return;
      }
      if (!target || !target.closest) return;
      /* Scrim or ✕ → close */
      if (target.closest('[data-vault-close]')) {
        if (e.cancelable) e.preventDefault();
        closeVault();
        return;
      }
      /* Category accordion → expand/collapse */
      var exp = target.closest('[data-vault-expand]');
      if (exp) {
        if (e.cancelable) e.preventDefault();
        e.stopImmediatePropagation();
        var group = exp.closest('[data-vault-group]');
        if (group) exp.setAttribute('aria-expanded', String(group.classList.toggle('tjd-vault__group--open')));
        return;
      }
    }

    document.addEventListener('click', function (e) {
      route(e.clientX, e.clientY, e.target, e);
    }, true);
    document.addEventListener('touchend', function (e) {
      var t = e.changedTouches && e.changedTouches[0];
      route(t ? t.clientX : -1, t ? t.clientY : -1, e.target, e);
    }, { capture: true, passive: false });

    /* ESC closes */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && vault.classList.contains('tjd-vault--open')) closeVault();
    });
  }

  /* ── Panel sub-group expand / collapse ───────────────────── */

  function initPanelGroups() {
    /* Desktop panel toggles */
    document.querySelectorAll('.mega-nav__group-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var group = btn.closest('.mega-nav__group');
        if (!group) return;
        var isOpen = group.classList.contains('mega-nav__group--open');
        group.classList.toggle('mega-nav__group--open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    /* Mobile drawer toggles */
    document.querySelectorAll('.mobile-mega-nav__group-toggle').forEach(function (btn) {
      function handleToggle(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var group = btn.closest('.mobile-mega-nav__group');
        if (!group) return;
        var isOpen = group.classList.contains('mobile-mega-nav__group--open');
        group.classList.toggle('mobile-mega-nav__group--open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      }
      btn.addEventListener('click',    handleToggle);
      btn.addEventListener('touchend', function (e) {
        e.preventDefault();
        handleToggle(e);
      }, { passive: false });
    });
  }

  /* ── Mobile drawer ────────────────────────────────────────── */

  var ACCORD_CLASS = 'is-open';

  function isOpen(drawer) {
    return drawer.classList.contains('mobile-mega-nav--open');
  }

  function openDrawer(drawer) {
    drawer.classList.add('mobile-mega-nav--open');
    drawer.setAttribute('aria-hidden', 'false');

    /* All styles forced inline — immune to CSS specificity / load order */
    drawer.style.display       = 'block';
    drawer.style.position      = 'fixed';
    drawer.style.top           = '0';
    drawer.style.left          = '0';
    drawer.style.right         = '0';
    drawer.style.bottom        = '0';
    drawer.style.zIndex        = '10000';
    drawer.style.background    = 'rgba(0,0,0,0.55)';
    drawer.style.pointerEvents = 'auto';
    drawer.style.opacity          = '0';
    drawer.style.backdropFilter       = 'blur(0px)';
    drawer.style.webkitBackdropFilter = 'blur(0px)';
    drawer.style.transition       = 'opacity 0.42s ease, backdrop-filter 0.42s ease, -webkit-backdrop-filter 0.42s ease';

    document.body.classList.add('mmn-open');
    document.body.style.overflow = 'hidden';

    /* Double rAF so the browser paints opacity:0 first, then transitions in —
       page behind softly dims and blurs as the drawer slides from the left. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.style.opacity          = '1';
        drawer.style.backdropFilter       = 'blur(4px)';
        drawer.style.webkitBackdropFilter = 'blur(4px)';
      });
    });
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('mobile-mega-nav--open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.style.opacity          = '0';
    drawer.style.backdropFilter       = 'blur(0px)';
    drawer.style.webkitBackdropFilter = 'blur(0px)';
    drawer.style.pointerEvents = 'none';

    document.body.classList.remove('mmn-open');
    document.body.style.overflow = '';

    /* Hide after transition completes */
    setTimeout(function () {
      if (!isOpen(drawer)) drawer.style.display = 'none';
    }, 450);
  }

  /* ── Hamburger positioning ───────────────────────────────── */

  function positionHamburger(el) {
    var header = document.querySelector('.header, .site-header, [data-header]');
    if (!header) return;
    var rect = header.getBoundingClientRect();
    el.style.top    = Math.max(0, Math.round(rect.top)) + 'px';
    el.style.height = header.offsetHeight + 'px';
  }

  /* ── Hit test: did this coordinate land inside an element? ── */

  function hits(el, x, y) {
    var r = el.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  /* ── Mobile init ─────────────────────────────────────────── */

  function initMobile() {
    var drawer = document.getElementById('mobile-mega-nav');
    if (!drawer) return;

    /* Move to <body> — survives any Stiletto header section re-render */
    document.body.appendChild(drawer);
    drawer.style.display = 'none'; /* start hidden via inline style */

    var trigger = document.getElementById('mobile-mega-nav-trigger');
    if (trigger) {
      document.body.appendChild(trigger);
      positionHamburger(trigger);
      window.addEventListener('scroll', function () {
        positionHamburger(trigger);
      }, { passive: true });
    }

    /* ── Hamburger toggle — capture phase, coordinate-based ──────
         capture: true  → fires before ANY other handler on the page,
                          including Stiletto's body/document listeners.
         Coordinate check → works even if another element sits on top
                            of the button visually.
         stopImmediatePropagation → prevents Stiletto from also reacting. */

    var lastFire = 0;

    function handleHamburger(x, y, e) {
      if (!trigger) return;
      if (!hits(trigger, x, y)) return;
      var now = Date.now();
      if (now - lastFire < 600) return;
      lastFire = now;
      e.stopImmediatePropagation();
      if (e.cancelable) e.preventDefault();
      if (isOpen(drawer)) { closeDrawer(drawer); }
      else                { openDrawer(drawer);  }
    }

    document.addEventListener('touchend', function (e) {
      var t = e.changedTouches && e.changedTouches[0];
      if (t) handleHamburger(t.clientX, t.clientY, e);
    }, { capture: true, passive: false });

    document.addEventListener('click', function (e) {
      handleHamburger(e.clientX, e.clientY, e);
    }, { capture: true });

    /* ── Close button (×) ── */
    var lastClose = 0;
    function handleClose(e) {
      if (!e.target.closest('[data-mobile-mega-close]')) return;
      var now = Date.now();
      if (now - lastClose < 400) return;
      lastClose = now;
      if (e.cancelable) e.preventDefault();
      closeDrawer(drawer);
    }
    drawer.addEventListener('touchend', handleClose, { passive: false });
    drawer.addEventListener('click',    handleClose);

    /* ── SHOP accordion ── */
    drawer.querySelectorAll('[data-mobile-accordion]').forEach(function (row) {
      var btn  = row.querySelector('[data-mobile-accordion-trigger]');
      var body = row.querySelector('[data-mobile-accordion-body]');
      if (!btn || !body) return;

      body.style.maxHeight  = '0';
      body.style.overflow   = 'hidden';
      body.style.transition = 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)';

      btn.addEventListener('click', function () {
        if (row.classList.contains(ACCORD_CLASS)) {
          row.classList.remove(ACCORD_CLASS);
          btn.setAttribute('aria-expanded', 'false');
          body.style.maxHeight = '0';
        } else {
          row.classList.add(ACCORD_CLASS);
          btn.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    /* ESC closes */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen(drawer)) closeDrawer(drawer);
    });
  }

  /* ── Hamburger colour tracks header transparency ─────────── */

  function watchHeaderTransparency() {
    var header = document.querySelector('.header');
    if (!header) return;
    function sync() {
      document.body.classList.toggle(
        'mmn-header-solid',
        !header.classList.contains('header--transparent')
      );
    }
    sync();
    new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── Boot ─────────────────────────────────────────────────── */

  function init() {
    initVault();
    initMobile();
    initPanelGroups();
    watchHeaderTransparency();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();